import { render, staticRenderFns } from "./invoiceSettingsPage.vue?vue&type=template&id=2ca91e18&"
import script from "./invoiceSettingsPage.vue?vue&type=script&lang=ts&"
export * from "./invoiceSettingsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports